import {WidgetType} from '@codemirror/view'

/** Renders a `br` element. */
export class LineBreakWidget extends WidgetType {
  toDOM() {
    return document.createElement('br')
  }

  override eq() {
    return true
  }
}
